const colorMap = {
  gold: 'text-mm-gold',
  sage: 'text-mm-sage',
  viridian: 'text-mm-viridian',
  persimmon: 'text-mm-persimmon',
  parchment: 'text-mm-parchment',
}

export default function StatNumber({ value, label, color = 'gold', size = 'lg' }) {
  const sizeClass = size === 'lg' ? 'text-5xl' : size === 'md' ? 'text-3xl' : 'text-2xl'

  return (
    <div className="text-center">
      <div className={`font-glacial-bold ${sizeClass} ${colorMap[color]} mb-1`}>
        {value}
      </div>
      {label && (
        <div className="text-[11px] text-mm-parchment/50 uppercase tracking-wide">
          {label}
        </div>
      )}
    </div>
  )
}
